export enum RouteKeys {
    RSVP = '/rsvp',
    COUPLE = '/about-couple',
    EVENTS = '/events',
    DETAILS = '/details',
}